import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

/**
 * 공동구매 product_item_cooperate, participation 등록/수정하기 (2024.03.07) - psh
 * @param param
 * @returns {Promise<*>}
 */
const postProductItemCooperate = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/productItem/cooperate/create`,
    param,
  );
  return data;
};

/**
 * 공동구매 product_item_option_coopearte 등록/수정하기 (2024.03.07) - psh
 * @param param
 * @returns {Promise<*>}
 */
const postProductItemOptionCooperate = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/productItem/cooperate/option/create`,
    param,
  );
  return data;
};
/**
 * 공동구매 product_item_option_coopearte 등록/수정하기 (2024.03.07) - psh
 * @param param
 * @returns {Promise<*>}
 */
const issueProductLinkCooperate = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/productLink/issue/cooperate`,
    param,
  );
  return data;
};

/**
 * [Plutus] 공동구매 목록 조회 for Admin (2024.03.07) - ksb
 * @param param
 * @param param.offset
 * @param param.pageSize
 * @param param.productId 상품 아이디 null-전체
 * @param param.brandName 브랜드명
 * @param param.productName 상품명
 * @param param.cooperateStatus 공동구매 상태 0-전체/1-예정/2-진행중/3-종료
 * @param param.influencerId 인플루언서 아이디 0-전체/PartnersUsers 테이블 아이디
 * @param param.orderType 정렬 조건 cooperate_start_date-공구시작일순/product_id-상품번호순/product_name-상품명순/influencer_name-인플루언서이름순/commission_rate-커미션순
 * @param param.orderBy 정렬 방향 desc/asc
 * @returns {Promise<never>}
 */
const getProductItemCooperate = async (param) => {
  const { data } = await axios.get(
    `${baseUrl}/productItem/admin/list/cooperate`,
    {
      params: param,
    },
  );
  return data;
};

/**
 * [Plutus] 공동구매 단일 조회 for Admin (2024.04.16) - ksb
 * @param param
 * @returns {Promise<never>}
 */
const getProductItemCooperateById = async (param) => {
  const { data } = await axios.get(
    `${baseUrl}/productItem/admin/cooperateInfo`,
    {
      params: param,
    },
  );
  return data;
};

const editProductItemCooperate = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/productItem/cooperate/edit`,
    param,
  );
  return data;
};

const CooperateApi = {
  postProductItemCooperate,
  postProductItemOptionCooperate,
  issueProductLinkCooperate,
  getProductItemCooperate,
  getProductItemCooperateById,
  editProductItemCooperate,
};

export default CooperateApi;
